var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParquet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-1,.cls-2{fill:none;}.cls-3{stroke:#eaa673;stroke-width:.12px;}.cls-3,.cls-4{fill:#be8966;}.cls-3,.cls-2{stroke-miterlimit:10;}.cls-5{fill:#f6ecdc;}.cls-6{fill:#f9b263;}.cls-7{fill:#f8e5be;}.cls-8{fill:#eee;}.cls-9{fill:#e8a760;}.cls-10{fill:#ececec;}.cls-11{fill:#ffd07e;}.cls-12{fill:#fbcd7a;}.cls-13{fill:#744f2c;}.cls-14{fill:#825d3f;}.cls-15{fill:#015a66;}.cls-16{fill:#9dd9f0;}.cls-17{fill:#c1eeff;}.cls-18{fill:#8c8c8c;}.cls-19{fill:#af7e49;}.cls-20{fill:#a57750;}.cls-21{fill:#a5764f;}.cls-22{fill:#b2b2b2;}.cls-23{fill:#bcab93;}.cls-24{fill:#bde3f7;}.cls-25{fill:#caecf6;}.cls-26{fill:#db9d6a;}.cls-27{fill:#e0bf90;}.cls-28{fill:#d8c5a7;}.cls-29{fill:#af8e6f;}.cls-30{fill:#c7f2fe;}.cls-31{fill:#8a6339;}.cls-32{fill:#577d8d;}.cls-33{fill:#587c94;}.cls-34{fill:#547b95;}.cls-2{stroke:#fff;stroke-width:.24px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parquet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parquet-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "97.24 71.65 48.92 100 0 71.65 48.64 43.91 97.24 71.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "100 28.37 97.21 30.14 88.28 24.83 88.91 24.25 60.12 7.53 59.2 7.89 51.67 3.68 6.11 30.14 2.76 28.42 51.67 0 100 28.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "51.67 94.1 51.67 98.05 50.54 97.39 18.83 79.01 2.76 69.7 2.76 28.42 6.11 30.14 6.11 66.02 5.98 66.26 6.11 66.34 6.11 67.4 18.83 74.85 50.54 93.43 51.67 94.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "100 28.37 100 69.7 51.67 98.05 51.67 94.1 97.21 67.5 97.21 66.34 97.21 66.2 97.21 66.02 97.21 30.14 100 28.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "87.57 46.64 87.57 48.2 75.37 41.33 75.37 17.87 76.84 18.71 76.84 40.71 87.57 46.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "73.77 38.75 73.77 40.31 61.58 33.44 61.58 9.97 63.05 10.85 63.05 32.81 73.77 38.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "97.21 30.14 97.21 65.23 51.68 38.13 51.67 38.13 51.67 3.68 59.2 7.89 59.2 34.51 88.28 50.91 88.28 24.83 97.21 30.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "88.28 50.16 88.28 50.91 59.2 34.51 59.2 7.89 60.12 7.53 60.12 34.23 88.28 50.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m60.12,7.53v26.69l28.15,15.93v-25.33l.64-.57L60.12,7.53Zm13.65,32.77l-12.2-6.87V9.97l12.16,7.25.03,23.09Zm13.79,7.89l-12.2-6.87v-23.46l1.47.84,10.73,6.12v23.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "97.22 65.23 97.22 67.5 51.69 94.1 50.55 93.43 18.84 74.85 6.13 67.4 6.13 64.53 51.69 38.13 97.22 65.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "51.67 3.68 51.67 38.13 6.11 64.53 6.11 30.14 51.67 3.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "55.08 65.35 55.07 66.5 52.62 65.1 52.62 63.94 55.08 65.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "59.54 67.92 59.54 69.07 55.07 66.5 55.08 65.35 59.54 67.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "97.13 64.71 97.13 65.86 75.79 78.41 75.8 77.25 97.13 64.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "75.8 77.25 75.79 78.41 59.54 69.07 59.54 67.92 75.8 77.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "97.13 64.71 75.8 77.25 59.54 67.92 55.08 65.35 52.62 63.94 29.16 77.74 6.66 64.59 51.46 38.25 74.86 51.8 80.22 54.91 80.88 55.29 81.94 55.91 90.58 60.91 91.74 61.58 97.13 64.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "52.62 63.94 52.62 65.1 29.16 78.89 29.16 77.74 52.62 63.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "29.16 77.74 29.16 78.89 6.66 65.75 6.66 64.59 29.16 77.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "56.05 40.62 56.04 41.31 51.66 38.75 51.67 38.06 56.05 40.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "51.67 38.06 51.66 38.75 40.4 45.37 40.4 44.68 51.67 38.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "40.35 44.71 40.35 45.4 40.32 45.39 40.32 44.69 40.35 44.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "56.05 40.62 56.04 41.31 44.78 47.93 44.78 47.24 56.05 40.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "56.15 40.62 56.14 41.31 45.38 47.64 45.38 46.95 56.15 40.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "44.78 47.24 44.78 47.93 40.4 45.37 40.4 44.68 44.78 47.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "51.67 38.06 56.05 40.62 44.78 47.24 40.4 44.68 51.67 38.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "40.4 44.68 40.4 45.37 19.6 57.6 19.61 56.91 40.4 44.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "44.73 47.27 44.73 47.96 40.35 45.4 40.35 44.71 44.73 47.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "44.8 47.25 44.8 47.94 44.75 47.97 44.75 47.28 44.8 47.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "44.8 47.25 44.75 47.28 44.73 47.27 40.35 44.71 40.32 44.69 40.37 44.66 40.4 44.68 44.78 47.24 44.8 47.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "44.75 47.28 44.75 47.97 44.73 47.96 44.73 47.27 44.75 47.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "19.56 56.93 19.56 57.63 19.53 57.61 19.53 56.92 19.56 56.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "44.73 47.27 44.73 47.96 23.98 60.16 23.99 59.47 44.73 47.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "45.38 46.95 45.38 47.64 27.48 58.16 27.49 57.47 45.38 46.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "23.99 59.47 23.98 60.16 19.6 57.6 19.61 56.91 23.99 59.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "23.94 59.49 23.94 60.19 19.56 57.63 19.56 56.93 23.94 59.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "23.97 59.51 23.96 60.2 23.94 60.19 23.94 59.49 23.97 59.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "24.01 59.48 24.01 60.17 23.96 60.2 23.97 59.51 24.01 59.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "19.61 56.91 19.6 57.6 8.66 64.04 8.66 63.35 19.61 56.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "24.01 59.48 23.97 59.51 23.94 59.49 19.56 56.93 19.53 56.92 19.58 56.89 19.61 56.91 23.99 59.47 24.01 59.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "8.66 63.35 19.56 56.93 23.94 59.49 13.04 65.91 8.66 63.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "13.04 65.91 13.04 66.6 8.66 64.04 8.66 63.35 13.04 65.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "23.94 59.49 23.94 60.19 13.04 66.6 13.04 65.91 23.94 59.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m51.66,38l4.48,2.62-10.77,6.33-17.89,10.52-10.32,6.07-4.13,2.43-4.48-2.62,43.11-25.35Zm-6.93,9.27l11.31-6.65-4.38-2.56-11.26,6.62-20.8,12.23-10.95,6.44,4.38,2.56,10.9-6.41,20.79-12.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "19.61 56.91 40.35 44.71 44.73 47.27 23.99 59.47 19.61 56.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "27.49 57.47 27.48 58.16 17.17 64.23 17.17 63.54 27.49 57.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "17.17 63.54 17.17 64.23 13.04 66.66 13.04 65.96 17.17 63.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "13.04 65.96 13.04 66.66 8.56 64.04 8.56 63.35 13.04 65.96"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "60.48 43.21 60.48 43.9 56.1 41.34 56.1 40.65 60.48 43.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "64.96 45.76 64.95 46.46 64.9 46.49 64.91 45.79 64.96 45.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "56.1 40.65 56.1 41.34 45.38 47.65 45.39 46.95 56.1 40.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "49.77 49.51 49.76 50.2 45.38 47.65 45.39 46.95 49.77 49.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "60.48 43.21 60.48 43.9 49.76 50.2 49.77 49.51 60.48 43.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "49.72 49.54 49.72 50.23 45.34 47.67 45.34 46.98 49.72 49.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "49.79 49.52 49.79 50.22 49.74 50.24 49.74 49.55 49.79 49.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "49.74 49.55 49.74 50.24 49.72 50.23 49.72 49.54 49.74 49.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "49.72 49.54 49.72 50.23 31.87 60.73 31.87 60.03 49.72 49.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "60.58 43.21 60.57 43.9 44.17 53.55 44.17 52.85 60.58 43.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "64.96 45.76 64.91 45.79 60.53 43.23 60.58 43.21 64.96 45.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "64.91 45.79 64.9 46.49 60.52 43.93 60.53 43.23 64.91 45.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "69.34 48.38 69.33 49.07 64.95 46.52 64.96 45.82 69.34 48.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "56.1 40.65 60.48 43.21 49.77 49.51 45.39 46.95 56.1 40.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "45.34 46.97 45.33 47.67 27.49 58.17 27.49 57.47 45.34 46.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "31.87 60.03 31.87 60.73 27.49 58.17 27.49 57.47 31.87 60.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "31.83 60.06 31.83 60.75 27.45 58.19 27.45 57.5 31.83 60.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "31.85 60.07 31.85 60.76 31.83 60.75 31.83 60.06 31.85 60.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "31.89 60.05 31.89 60.74 31.85 60.76 31.85 60.07 31.89 60.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "27.44 57.5 27.44 58.19 17.22 64.2 17.23 63.51 27.44 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "21.61 66.07 21.6 66.76 17.22 64.2 17.23 63.51 21.61 66.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "31.89 60.05 31.85 60.07 31.83 60.06 27.45 57.5 27.49 57.47 31.87 60.03 31.89 60.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "31.83 60.06 31.83 60.75 21.6 66.76 21.61 66.07 31.83 60.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "56.15 40.62 45.39 46.95 56.1 40.65 60.48 43.21 49.72 49.54 31.87 60.03 31.89 60.05 31.85 60.07 31.83 60.06 31.83 60.06 21.61 66.07 17.23 63.51 27.44 57.5 17.17 63.54 21.6 66.12 44.17 52.85 60.58 43.21 56.15 40.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "49.79 49.52 49.74 49.55 49.72 49.54 45.34 46.98 45.38 46.95 49.77 49.51 49.79 49.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "73.82 50.94 73.81 51.63 73.76 51.66 73.77 50.97 73.82 50.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "69.34 48.38 69.33 49.07 46.76 62.35 46.76 61.66 69.34 48.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "69.44 48.38 69.44 49.07 57.87 55.87 57.87 55.18 69.44 48.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "73.77 50.97 73.76 51.66 69.38 49.1 69.39 48.41 73.77 50.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "73.82 50.94 73.77 50.97 69.39 48.41 69.44 48.38 73.82 50.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "78.3 53.56 78.3 54.25 78.22 54.2 78.22 53.51 78.3 53.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "78.2 53.56 78.2 54.25 73.82 51.69 73.82 51 78.2 53.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "48.55 55.41 48.54 56.11 44.17 53.55 44.17 52.85 48.55 55.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "64.91 45.79 64.9 46.49 48.54 56.11 48.55 55.41 64.91 45.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "60.53 43.23 64.91 45.79 48.55 55.41 44.17 52.85 60.53 43.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "48.55 55.41 48.54 56.11 48.49 56.14 48.5 55.44 48.55 55.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "44.17 52.85 44.17 53.55 21.6 66.82 21.6 66.12 44.17 52.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "48.5 55.44 48.49 56.14 44.11 53.58 44.12 52.88 48.5 55.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "48.5 55.44 48.49 56.14 22.73 71.29 22.73 70.59 48.5 55.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "64.96 45.82 64.95 46.52 42.38 59.79 42.38 59.1 64.96 45.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "46.76 61.66 46.76 62.35 42.38 59.79 42.38 59.1 46.76 61.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "69.34 48.38 46.76 61.66 42.38 59.1 64.96 45.82 69.34 48.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m64.96,45.76l4.48,2.62-11.56,6.8-11.11,6.53-4.43-2.59,6.16-3.68,16.46-9.68Zm-18.19,15.89l22.57-13.27-4.38-2.56-22.57,13.27,4.38,2.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "48.55 55.41 48.5 55.44 44.12 52.88 44.17 52.85 48.55 55.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "78.2 53.56 78.2 54.25 57.31 66.53 57.31 65.84 78.2 53.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "78.3 53.56 78.3 54.25 57.31 66.59 57.31 65.9 78.3 53.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "82.58 56.14 82.58 56.84 78.25 54.31 78.25 53.61 82.58 56.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "73.77 50.97 73.76 51.66 62.25 58.43 62.25 57.74 73.77 50.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "62.25 57.74 62.25 58.43 57.87 55.87 57.87 55.18 62.25 57.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "69.39 48.41 73.77 50.97 62.25 57.74 57.87 55.18 69.39 48.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "57.87 55.18 57.87 55.87 46.76 62.41 46.76 61.72 57.87 55.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "62.25 57.74 62.2 57.77 57.82 55.21 57.87 55.18 62.25 57.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "62.2 57.77 62.2 58.46 57.82 55.9 57.82 55.21 62.2 57.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "62.25 57.74 62.25 58.43 62.2 58.46 62.2 57.77 62.25 57.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "27.49 57.47 45.34 46.98 49.72 49.54 31.87 60.03 27.49 57.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "46.76 61.72 46.76 62.41 42.33 59.82 42.33 59.13 46.76 61.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "62.2 57.77 62.2 58.46 46.22 67.86 46.22 67.17 62.2 57.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "73.82 51 73.82 51.69 52.93 63.98 52.93 63.28 73.82 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "52.88 63.31 52.88 64.01 52.82 63.98 52.83 63.28 52.88 63.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "46.76 61.72 46.76 62.41 41.84 65.3 41.84 64.61 46.76 61.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "57.31 65.84 57.31 66.53 52.93 63.98 52.93 63.28 57.31 65.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "78.2 53.56 57.31 65.84 52.93 63.28 73.82 51 78.2 53.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "57.23 65.85 57.23 66.55 52.88 64.01 52.88 63.31 57.23 65.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "78.25 53.61 78.25 54.31 57.4 66.56 57.4 65.87 78.25 53.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m78.22,53.51l.08.05-20.99,12.34-.08-.05-4.35-2.54-.05-.03,9.38-5.51.05-.03,11.56-6.8,4.4,2.57Zm-20.91,12.33l20.89-12.28-4.38-2.56-20.89,12.28,4.38,2.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "57.31 65.9 57.31 66.59 57.23 66.55 57.23 65.85 57.31 65.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "17.23 63.51 27.45 57.5 31.83 60.06 21.61 66.07 17.23 63.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "21.6 66.12 21.6 66.82 17.17 64.23 17.17 63.54 21.6 66.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "46.22 67.17 46.22 67.86 41.84 65.3 41.84 64.61 46.22 67.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "46.76 61.72 57.82 55.21 62.2 57.77 46.22 67.17 41.84 64.61 46.76 61.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "52.83 63.28 52.88 63.31 46.22 67.23 41.74 64.61 46.71 61.69 46.76 61.72 41.84 64.61 46.22 67.17 52.83 63.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "52.88 63.31 52.88 64.01 46.22 67.92 46.22 67.23 52.88 63.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "46.22 67.23 46.22 67.92 41.73 65.3 41.74 64.61 46.22 67.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "21.56 66.1 21.55 66.79 18.35 68.73 18.35 68.03 21.56 66.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "82.58 56.14 61.73 68.4 57.4 65.87 78.25 53.61 82.58 56.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "61.73 68.4 61.73 69.09 57.4 66.56 57.4 65.87 61.73 68.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "82.58 56.14 82.58 56.84 61.73 69.09 61.73 68.4 82.58 56.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "61.73 68.52 61.73 69.21 57.2 66.56 57.2 65.87 61.73 68.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m78.22,53.51l4.55,2.63-21.04,12.37-4.53-2.65.11.03,20.99-12.34-.08-.05Zm-16.49,14.89l20.85-12.26-4.33-2.53-20.85,12.26,4.33,2.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "82.77 56.15 82.77 56.84 61.73 69.21 61.73 68.52 82.77 56.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "21.6 66.12 44.12 52.88 48.5 55.44 22.73 70.59 18.35 68.03 21.6 66.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "22.73 70.59 22.73 71.29 18.35 68.73 18.35 68.03 22.73 70.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "42.33 59.13 42.33 59.82 22.73 71.34 22.73 70.65 42.33 59.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "42.28 59.1 42.33 59.13 22.73 70.65 18.26 68.04 21.56 66.1 18.35 68.03 22.73 70.59 42.28 59.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "22.73 70.65 22.73 71.34 18.26 68.73 18.26 68.04 22.73 70.65"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "47.59 88.03 47.59 89.8 44.22 87.72 44.22 86.21 47.59 88.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "50.65 86.24 50.65 88.03 47.59 89.8 47.59 88.03 50.65 86.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "62.62 75.85 62.62 77.53 61.36 78.26 61.36 76.58 62.62 75.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "61.36 76.58 61.36 78.26 50.65 84.45 50.65 82.8 61.36 76.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "61.36 76.58 61.36 76.58 57.83 74.54 59.01 73.84 62.62 75.85 61.36 76.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "50.65 82.8 50.65 82.8 47.59 84.58 47.55 84.6 44.22 82.7 45.63 81.85 45.63 81.85 50.65 82.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "61.36 76.58 61.36 76.58 50.65 82.8 45.63 81.85 57.83 74.54 57.83 74.54 61.36 76.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "62.62 77.53 62.62 79.25 61.36 79.99 61.36 78.26 62.62 77.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "61.36 78.26 61.36 79.99 50.65 86.24 50.65 84.45 61.36 78.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "62.62 79.25 62.62 81.09 61.36 81.82 61.36 79.99 62.62 79.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "61.36 79.99 61.36 81.82 50.65 88.03 50.65 86.24 61.36 79.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.83,
    y1: 74.54,
    x2: 57.83,
    y2: 74.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "47.59 84.58 47.59 86.21 44.22 84.35 44.22 82.7 47.55 84.6 47.59 84.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "50.65 82.8 50.65 84.45 47.59 86.21 47.59 84.58 50.65 82.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "47.59 86.21 47.59 88.03 44.22 86.21 44.22 84.35 47.59 86.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "50.65 84.45 50.65 86.24 47.59 88.03 47.59 86.21 50.65 84.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "52.66 89.5 52.66 91.27 49.29 89.19 49.29 87.69 52.66 89.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "55.72 87.71 55.72 89.5 52.66 91.27 52.66 89.5 55.72 87.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "67.69 77.32 67.69 79 66.43 79.73 66.43 78.05 67.69 77.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "66.43 78.05 66.43 79.73 55.72 85.92 55.72 84.27 66.43 78.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "66.43 78.05 66.43 78.05 62.9 76.01 64.08 75.31 67.69 77.32 66.43 78.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "55.72 84.27 55.72 84.27 52.66 86.05 52.62 86.07 49.29 84.17 50.7 83.32 50.7 83.32 55.72 84.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.43 78.05 66.43 78.05 55.72 84.27 50.7 83.32 62.9 76.01 62.9 76.01 66.43 78.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "67.69 79 67.69 80.73 66.43 81.46 66.43 79.73 67.69 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "66.43 79.73 66.43 81.46 55.72 87.71 55.72 85.92 66.43 79.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "67.69 80.73 67.69 82.56 66.43 83.29 66.43 81.46 67.69 80.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "66.43 81.46 66.43 83.29 55.72 89.5 55.72 87.71 66.43 81.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.9,
    y1: 76.01,
    x2: 62.9,
    y2: 76.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "52.66 86.05 52.66 87.69 49.29 85.82 49.29 84.17 52.62 86.07 52.66 86.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "55.72 84.27 55.72 85.92 52.66 87.69 52.66 86.05 55.72 84.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "52.66 87.69 52.66 89.5 49.29 87.69 49.29 85.82 52.66 87.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "55.72 85.92 55.72 87.71 52.66 89.5 52.66 87.69 55.72 85.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "41.06 86.83 46.21 89.8 47.59 89.8 44.22 87.72 44.22 84.89 41.06 86.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.12 89.5 50.97 91.27 52.51 91.27 49.29 89.19 49.29 88.82 48.12 89.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParquet);
export default __webpack_public_path__ + "static/media/parquet.220ae992a050c5e29bbbbd89e9a5a972.svg";
export { ForwardRef as ReactComponent };